
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 229.167 149.167","fill":"#fff","fill-rule":"evenodd","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#email","x":"2.083","y":"2.083"}}),_c('symbol',{attrs:{"id":"email","overflow":"visible"}},[_c('path',{attrs:{"d":"M145 78.358l-30.417 25.1-30.417-25.096-80 65.983H225l-55.208-45.542zm-74.167-4.125L0 4.167v140.221l35.417-35.058zM112.5 94.85L225 0H0l56.25 47.429zm77.083-55.67l-35.417 35.058L225 144.35V4.167z","stroke":"none","fill":"currentColor"}})])])
          )
        }
      }
    